module.exports = __webpack_public_path__ + "img/outDNAbelow.2ff0e72f.png";